/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import axios from "axios";
import { getToken } from "../../../auth";
//BASE_URL
const API_URL = process.env.REACT_APP_API_URL;
const Review_URL = `${API_URL}`;

const listReviewData = async ( filterData: any) => {
  const response = await axios.post(`${API_URL}list-dish-review`,filterData , getToken());
  return response.data;
};

const viewReviewById = async (id: any) => {
  const response = await axios.get(`${Review_URL}/view-dish-review/${id}`, getToken());
  return response.data;
};


export {
  listReviewData,
  viewReviewById,
};
